// extracted by mini-css-extract-plugin
module.exports = {"inline-link-standalone":"section-link_inline-link-standalone__aaESO"};